import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { TrackingEventRegistry } from "./TrackingEventRegistry";
import { Logger } from "@leavy/logger";
let TrackingEventDispatcher = class TrackingEventDispatcher {
    constructor(trackingEventRegistry, logger) {
        this.trackingEventRegistry = trackingEventRegistry;
        this.logger = logger;
        this.handlers = [];
    }
    registerHandler(handler) {
        this.handlers.push(handler);
    }
    async dispatch(...args) {
        const value = args.length == 1 ? args[0] : args[1];
        const name = args.length == 2 ? args[0] : this.trackingEventRegistry.getEventName(value);
        this.logger.debug("Dispatching tracking event", { name, value });
        for (const handler of this.handlers) {
            await handler.onTrackingEvent({ name, value });
        }
    }
    async dispatchByName(eventName, eventPayload) {
        const eventCtor = this.trackingEventRegistry.registry.get(eventName);
        const eventObj = Object.assign(new eventCtor(), eventPayload);
        await this.dispatch(eventName, eventObj);
    }
};
TrackingEventDispatcher = __decorate([
    injectable(),
    __metadata("design:paramtypes", [TrackingEventRegistry,
        Logger])
], TrackingEventDispatcher);
export { TrackingEventDispatcher };
//# sourceMappingURL=TrackingEventDispatcher.js.map